<div class="css-progress-bar-container">
  <span *ngIf="showFillLevel" class="css-progress-bar-fill-level">{{
    fillLevel + "%"
  }}</span>
  <div class="css-progress-bar-item-container">
    <div class="css-progress-bar-item" [ngStyle]="getStyle()"></div>
  </div>
</div>
